<template>
  <div :class="componentClassName">
    <a-page-heading>契約情報確認・変更 </a-page-heading>

    <m-section variant="fullpage">
      <m-action-card title="支払い方法" icon="credit-card" :narrow-body="true">
        <form ref="form" class="t-contract-edit-payment__form" @submit.prevent="handleFormSubmit">
          <div class="t-contract-edit-payment__fields">
            <div class="t-contract-edit-payment__options">
              <m-payment-radio
                v-model="formData.payment_method"
                v-model:card-number="formData.card_number"
                v-model:card-expiry="formData.card_expiry"
                v-model:card-holder="formData.card_holder"
                v-model:card-cvv="formData.card_cvv"
                label="クレジットカードによる支払い"
                name="payment_method"
                value="credit-card"
                type="credit-card"
              />
              <m-payment-radio
                v-model="formData.payment_method"
                v-model:invoice-address="formData.invoice_address"
                v-model:invoice-phone="formData.invoice_phone"
                v-model:invoice-street="formData.invoice_street"
                v-model:invoice-same-address="formData.invoice_same_address"
                label="請求書による支払い"
                sublabel="同封の申し込み書の送付によって口座振替も可能です。"
                name="payment_method"
                value="invoice"
                type="invoice"
              />
            </div>
            <m-form-action-buttons>
              <a-button variant="block" color="primary" submit="submit">保存</a-button>
              <a-button variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import MPaymentRadio from '@/components/molecules/payment-radio';
import { cloneDeep } from 'lodash';

export default {
  name: 't-contract-edit-payment',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    AButton,
    MPaymentRadio,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleSaveClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        payment_method: 'credit-card',
        card_number: '',
        card_expiry: '',
        card_holder: '',
        card_cvv: '',
        invoice_address: '',
        invoice_phone: '',
        invoice_street: '',
        invoice_same_address: true,
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-payment');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      const data = cloneDeep(this.formData);
      const payload = {
        payment_method: data.payment_method,
      };
      if (data.payment_method === 'invoice') {
        payload.invoice_address = data.invoice_address;
        payload.invoice_phone = data.invoice_phone;
        payload.invoice_street = data.invoice_street;
        payload.invoice_same_address = data.invoice_same_address;
      } else {
        payload.card_number = data.card_number;
        payload.card_expiry = data.card_expiry;
        payload.card_holder = data.card_holder;
        payload.card_cvv = data.card_cvv;
      }
      this.handleSaveClick(payload);
    },
  },
};
</script>
